import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from "@/components/ui/tooltip";
import { FaInfoCircle } from "react-icons/fa";

const InfoTooltip = ({ description }) => (
  <TooltipProvider delayDuration={300}>
    <Tooltip placement="right">
      <TooltipTrigger>
        <FaInfoCircle className="text-gray-500 cursor-pointer" />
      </TooltipTrigger>
      <TooltipContent className="bg-white border border-gray-200 text-sm text-gray-700 p-2 rounded shadow-md z-10 whitespace-nowrap">
        {description}
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
);

export default InfoTooltip;
